import GalleryRows from '@/components/GalleryRows';

export default function Gallery() {
  return (
    <div>
      <section className="relative py-24 bg-royal-dark text-white overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1519452575417-564c1401ecc0?w=2400" alt="" className="w-full h-full object-cover opacity-30" />
        </div>
        <div className="relative max-w-5xl mx-auto px-6 text-center">
          <div className="overline text-gold mb-3">Gallery</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold gold-underline">Moments From the Jurisdiction</h1>
          <p className="mt-4 text-white/85 text-lg max-w-3xl mx-auto">A visual record of our worship, conferences, and community across Wisconsin.</p>
        </div>
      </section>
      <GalleryRows scope="main" wrapClass="bg-white py-16" innerClass="max-w-6xl mx-auto px-6" />
    </div>
  );
}
